import { useMemo } from "react";

import { useAppShellBreadcrumb } from "@/shared/components/layout/useAppShellBreadcrumb";
import useTranslations from "@/shared/lang/useTranslations";

import { QuoterForm } from "../../quoter/components/QuoterForm";
import { QUOTER_COUNTRIES } from "../../quoter/constants/quoter.constants";
import { buildCurrencyOptionsFromCountries } from "../../quoter/utils/currencyOptions.utils";

const COLOCA_DISPLAY_CONFIG = {
  hideCommissionLine: true,
  hideConvertedRow: true,
  showEffectiveRate: true,
  hideExchangeRateCard: true,
} as const;

// The country/currency table is a local constant now (the legacy PHP catalog fetch is gone),
// so there is no loading or error state to render.
const CURRENCY_OPTIONS = buildCurrencyOptionsFromCountries(QUOTER_COUNTRIES);

export const QuoterColocaPage = () => {
  const { t: tGlobal } = useTranslations("global");
  const breadcrumb = useMemo(
    () => [
      { label: tGlobal("sidebar_section_gestion") },
      { label: tGlobal("sidebar_menu_quoter_coloca"), to: "/app/quoter-coloca" },
    ],
    [tGlobal],
  );
  useAppShellBreadcrumb(breadcrumb);

  // Access is enforced by the route-level `RequireAccess` gate (payments:read + userTypes: [INTERNAL],
  // from the rates endpoint this form calls). The old local check defaulted to `true`.
  return (
    <div className="space-y-6 p-2 flex justify-center">
      <QuoterForm
        currencyOptions={CURRENCY_OPTIONS}
        displayConfig={COLOCA_DISPLAY_CONFIG}
        headerTitleSuffix=" Coloca"
      />
    </div>
  );
};
